module.exports = __webpack_public_path__ + "img/delete-icon.b4fd8ca8.svg";